let _navigate = null;

export function setNavigate(navigateFn) {
    _navigate = navigateFn;
}

export function navigate(path, options) {
    if (_navigate) _navigate(path, options);
}
